import { render, staticRenderFns } from "./TeachingPlanSetting.vue?vue&type=template&id=2e742add&"
import script from "./TeachingPlanSetting.vue?vue&type=script&lang=js&"
export * from "./TeachingPlanSetting.vue?vue&type=script&lang=js&"
import style0 from "./TeachingPlanSetting.vue?vue&type=style&index=0&id=2e742add&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports